import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";

import FixedValueForm from "../types/FixedValueForm";

export const ProfileMomentDayForm = ({
  visible,
  onClose,
  node,
  onSave,
  onRemove,
}) => {
  const options = [
    { label: "Almoço", value: 1 },
    { label: "Jantar", value: 2 },
    { label: "Madrugada", value: 4 },
  ];

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.ProfileMomentDay}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <FixedValueForm
        timerange={false}
        node={node}
        options={options}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
      />
    </Drawer>
  );
};
